import {
   GynecologicalInterview,
   PatientPregnant,
   PregnancyCompletion,
   RegularInterview,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { AttachmentsLinks } from '~legacy.patient';

import { GynecologicalInterviewPatientPregnantCategoryContent } from './GynecologicalInterviewPatientPregnantCategoryContent';
import { GynecologicalInterviewPregnancyCompletionCategoryContent } from './GynecologicalInterviewPregnancyCompletionCategoryContent';
import { GynecologicalInterviewRegularInterviewCategoryContent } from './GynecologicalInterviewRegularInterviewCategoryContent';

type GynecologicalInterviewCategoryContentProps = {
   readonly onShowMoreAttachmentsClick: VoidFunction;
   readonly gynecologicalInterview: GynecologicalInterview;
};

const isGynecologicalInterviewPatientPregnant = (
   gynecologicalInterview: GynecologicalInterview
): gynecologicalInterview is PatientPregnant =>
   gynecologicalInterview.class === 'egabinet-patient-medical-information-frontend-api:PatientPregnant';

const isGynecologicalInterviewPregnancyCompletion = (
   gynecologicalInterview: GynecologicalInterview
): gynecologicalInterview is PregnancyCompletion =>
   gynecologicalInterview.class === 'egabinet-patient-medical-information-frontend-api:PregnancyCompletion';

const isGynecologicalInterviewRegular = (
   gynecologicalInterview: GynecologicalInterview
): gynecologicalInterview is RegularInterview =>
   gynecologicalInterview.class === 'egabinet-patient-medical-information-frontend-api:RegularInterview';

export const GynecologicalInterviewCategoryContent = (
   props: GynecologicalInterviewCategoryContentProps
): JSX.Element => {
   return (
      <StyledFlex direction='column' gap='12px'>
         {isGynecologicalInterviewPatientPregnant(props.gynecologicalInterview) ? (
            <GynecologicalInterviewPatientPregnantCategoryContent
               patientPregnantInterview={props.gynecologicalInterview}
            />
         ) : null}
         {isGynecologicalInterviewPregnancyCompletion(props.gynecologicalInterview) ? (
            <GynecologicalInterviewPregnancyCompletionCategoryContent
               pregnancyCompletionInterview={props.gynecologicalInterview}
            />
         ) : null}
         {isGynecologicalInterviewRegular(props.gynecologicalInterview) ? (
            <GynecologicalInterviewRegularInterviewCategoryContent
               description={props.gynecologicalInterview.description}
            />
         ) : null}
         {props.gynecologicalInterview.attachments ? (
            <AttachmentsLinks
               attachments={props.gynecologicalInterview.attachments}
               onShowMoreAttachmentsClick={props.onShowMoreAttachmentsClick}
            />
         ) : null}
      </StyledFlex>
   );
};
